import {gql, useQuery} from '@apollo/client';

/** DSP 下拉选项（含联系电话），与 Kotlin DspContactOptionType 对齐 */
export interface DspContactOption {
    id: string;
    name: string;
    dspCode?: string | null;
    contactPhone?: string | null;
}

export const GET_DSP_CONTACT_OPTIONS = gql`
    query GetDspContactOptions {
        getDspContactOptions {
            id
            name
            dspCode
            contactPhone
        }
    }
`;

interface GetDspContactOptionsResponse {
    getDspContactOptions: DspContactOption[];
}

export const useDspContactOptions = () => {
    const {data, loading, error} = useQuery<GetDspContactOptionsResponse>(GET_DSP_CONTACT_OPTIONS);
    return {
        dsps: data?.getDspContactOptions ?? [],
        loading,
        error,
    };
};
